// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/SalesPages/CashInModal.module.css */

:root {
  --green: rgba(24, 115, 70, 1);
  --green-2: rgba(29, 135, 82, 1);
  --border: rgba(229, 231, 235, 1);
  --bg: #ffffff;
  --muted: #6b7280;
  --text: #111827;
}

.CashInModal_modal__TvFLH {
  width: 900px;
  height: 600px;
  display: flex;
  overflow: hidden;
  border-radius: 16px;
  padding: 0; /* перекрываем базовую модалку, если нужно */
}

.CashInModal_left__PvMCD {
  flex: 0 0 40%;
  background: #f7faf8;
  padding: 20px;
  border-right: 1px solid var(--border);
}

.CashInModal_right__4K43r {
  flex: 1 1;
  padding: 20px;
  background: var(--bg);
}

.CashInModal_top__js8FT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.CashInModal_subTitle__OjTWq {
  font-size: 12px;
  color: var(--muted);
}

.CashInModal_balance__YGAWA {
  font-size: 24px;
  font-weight: 900;
  color: var(--green);
  margin-top: 4px;
}

.CashInModal_walletLine__Xg0yd {
  font-size: 12px;
  color: #9aa0a6;
  margin-top: 6px;
}

.CashInModal_quickGrid__yRWcY {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-bottom: 16px;
}

.CashInModal_quickBtn__HBWFI {
  padding: 14px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 800;
  transition: 0.15s ease;
}

.CashInModal_quickBtn__HBWFI:hover {
  border-color: rgba(24, 115, 70, 0.35);
  box-shadow: 0 6px 18px rgba(24, 115, 70, 0.12);
}

.CashInModal_pad__eFPe- {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.CashInModal_keyBtn__QUWJv {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: #fff;
  cursor: pointer;
  font-size: 22px;
  font-weight: 900;
  transition: 0.15s ease;
}

.CashInModal_keyBtn__QUWJv:hover {
  border-color: rgba(24, 115, 70, 0.35);
  box-shadow: 0 6px 18px rgba(24, 115, 70, 0.12);
}

.CashInModal_clearBtn__TsqIZ {
  margin-top: 12px;
  grid-column: 1 / -1;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(220, 38, 38, 0.2);
  background: rgba(220, 38, 38, 0.08);
  cursor: pointer;
  font-size: 18px;
  font-weight: 900;
  color: rgba(220, 38, 38, 1);
}

.CashInModal_form__5D6nS {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.CashInModal_field__2ONcV {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.CashInModal_label__HdDO5 {
  font-size: 13px;
  font-weight: 800;
  color: var(--text);
}

.CashInModal_amountInputWrap__5gcLt {
  display: flex;
  align-items: center;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 10px 12px;
  transition: 0.15s ease;
}

.CashInModal_amountInputWrap__5gcLt:focus-within {
  border-color: rgba(24, 115, 70, 0.5);
  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);
}

.CashInModal_amountInput__py4EK {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: var(--text);
  background: transparent;
}

.CashInModal_currency__ZYCZ6 {
  font-weight: 900;
  color: var(--green);
}

.CashInModal_select__sovko {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  border: 1px solid var(--border);
  padding: 0 12px;
  outline: none;
  font-weight: 700;
  transition: 0.15s ease;
}

.CashInModal_select__sovko:focus {
  border-color: rgba(24, 115, 70, 0.5);
  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);
}

.CashInModal_textarea__qzeiz {
  width: 100%;
  min-height: 92px;
  border-radius: 12px;
  border: 1px solid var(--border);
  padding: 12px;
  outline: none;
  resize: none;
  font-weight: 600;
  transition: 0.15s ease;
}

.CashInModal_textarea__qzeiz:focus {
  border-color: rgba(24, 115, 70, 0.5);
  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);
}

.CashInModal_counter__uhxrP {
  font-size: 12px;
  color: #9aa0a6;
}

.CashInModal_actions__ZZcWe {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 10px;
}

.CashInModal_cancelBtn__7iCML {
  height: 44px;
  padding: 0 22px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: #fff;
  cursor: pointer;
  font-weight: 800;
  transition: 0.15s ease;
}

.CashInModal_cancelBtn__7iCML:hover {
  border-color: rgba(24, 115, 70, 0.35);
}

.CashInModal_primaryBtn__Cmk5I {
  height: 44px;
  padding: 0 22px;
  border-radius: 12px;
  border: none;
  background: var(--green);
  color: #fff;
  cursor: pointer;
  font-weight: 900;
  transition: 0.15s ease;
}

.CashInModal_primaryBtn__Cmk5I:hover {
  background: var(--green-2);
  box-shadow: 0 8px 22px rgba(24, 115, 70, 0.18);
}

.CashInModal_primaryBtn__Cmk5I:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/CashInModal.module.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,UAAU,EAAE,4CAA4C;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* src/pages/SalesPages/CashInModal.module.css */\n\n:root {\n  --green: rgba(24, 115, 70, 1);\n  --green-2: rgba(29, 135, 82, 1);\n  --border: rgba(229, 231, 235, 1);\n  --bg: #ffffff;\n  --muted: #6b7280;\n  --text: #111827;\n}\n\n.modal {\n  width: 900px;\n  height: 600px;\n  display: flex;\n  overflow: hidden;\n  border-radius: 16px;\n  padding: 0; /* перекрываем базовую модалку, если нужно */\n}\n\n.left {\n  flex: 0 0 40%;\n  background: #f7faf8;\n  padding: 20px;\n  border-right: 1px solid var(--border);\n}\n\n.right {\n  flex: 1;\n  padding: 20px;\n  background: var(--bg);\n}\n\n.top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.subTitle {\n  font-size: 12px;\n  color: var(--muted);\n}\n\n.balance {\n  font-size: 24px;\n  font-weight: 900;\n  color: var(--green);\n  margin-top: 4px;\n}\n\n.walletLine {\n  font-size: 12px;\n  color: #9aa0a6;\n  margin-top: 6px;\n}\n\n.quickGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.quickBtn {\n  padding: 14px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: #fff;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 800;\n  transition: 0.15s ease;\n}\n\n.quickBtn:hover {\n  border-color: rgba(24, 115, 70, 0.35);\n  box-shadow: 0 6px 18px rgba(24, 115, 70, 0.12);\n}\n\n.pad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.keyBtn {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: #fff;\n  cursor: pointer;\n  font-size: 22px;\n  font-weight: 900;\n  transition: 0.15s ease;\n}\n\n.keyBtn:hover {\n  border-color: rgba(24, 115, 70, 0.35);\n  box-shadow: 0 6px 18px rgba(24, 115, 70, 0.12);\n}\n\n.clearBtn {\n  margin-top: 12px;\n  grid-column: 1 / -1;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(220, 38, 38, 0.2);\n  background: rgba(220, 38, 38, 0.08);\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: 900;\n  color: rgba(220, 38, 38, 1);\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.label {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--text);\n}\n\n.amountInputWrap {\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 10px 12px;\n  transition: 0.15s ease;\n}\n\n.amountInputWrap:focus-within {\n  border-color: rgba(24, 115, 70, 0.5);\n  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);\n}\n\n.amountInput {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 16px;\n  color: var(--text);\n  background: transparent;\n}\n\n.currency {\n  font-weight: 900;\n  color: var(--green);\n}\n\n.select {\n  width: 100%;\n  height: 44px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  padding: 0 12px;\n  outline: none;\n  font-weight: 700;\n  transition: 0.15s ease;\n}\n\n.select:focus {\n  border-color: rgba(24, 115, 70, 0.5);\n  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);\n}\n\n.textarea {\n  width: 100%;\n  min-height: 92px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  padding: 12px;\n  outline: none;\n  resize: none;\n  font-weight: 600;\n  transition: 0.15s ease;\n}\n\n.textarea:focus {\n  border-color: rgba(24, 115, 70, 0.5);\n  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);\n}\n\n.counter {\n  font-size: 12px;\n  color: #9aa0a6;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.cancelBtn {\n  height: 44px;\n  padding: 0 22px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: #fff;\n  cursor: pointer;\n  font-weight: 800;\n  transition: 0.15s ease;\n}\n\n.cancelBtn:hover {\n  border-color: rgba(24, 115, 70, 0.35);\n}\n\n.primaryBtn {\n  height: 44px;\n  padding: 0 22px;\n  border-radius: 12px;\n  border: none;\n  background: var(--green);\n  color: #fff;\n  cursor: pointer;\n  font-weight: 900;\n  transition: 0.15s ease;\n}\n\n.primaryBtn:hover {\n  background: var(--green-2);\n  box-shadow: 0 8px 22px rgba(24, 115, 70, 0.18);\n}\n\n.primaryBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `CashInModal_modal__TvFLH`,
	"left": `CashInModal_left__PvMCD`,
	"right": `CashInModal_right__4K43r`,
	"top": `CashInModal_top__js8FT`,
	"subTitle": `CashInModal_subTitle__OjTWq`,
	"balance": `CashInModal_balance__YGAWA`,
	"walletLine": `CashInModal_walletLine__Xg0yd`,
	"quickGrid": `CashInModal_quickGrid__yRWcY`,
	"quickBtn": `CashInModal_quickBtn__HBWFI`,
	"pad": `CashInModal_pad__eFPe-`,
	"keyBtn": `CashInModal_keyBtn__QUWJv`,
	"clearBtn": `CashInModal_clearBtn__TsqIZ`,
	"form": `CashInModal_form__5D6nS`,
	"field": `CashInModal_field__2ONcV`,
	"label": `CashInModal_label__HdDO5`,
	"amountInputWrap": `CashInModal_amountInputWrap__5gcLt`,
	"amountInput": `CashInModal_amountInput__py4EK`,
	"currency": `CashInModal_currency__ZYCZ6`,
	"select": `CashInModal_select__sovko`,
	"textarea": `CashInModal_textarea__qzeiz`,
	"counter": `CashInModal_counter__uhxrP`,
	"actions": `CashInModal_actions__ZZcWe`,
	"cancelBtn": `CashInModal_cancelBtn__7iCML`,
	"primaryBtn": `CashInModal_primaryBtn__Cmk5I`
};
export default ___CSS_LOADER_EXPORT___;
